module.exports = __webpack_public_path__ + "img/plb7.6fd88ebf.png";